export default __webpack_public_path__ + "static/media/mee.3d455234.jpg";